/**
 * Per-firm logo rendering metadata.
 *
 * `invertInLight` matches the landing site's `firm_profiles.invert_in_light` flag:
 * the firm's logo art is near-white/monochrome, so in light mode we need an
 * outline shadow to make it legible against a white background. In dark mode
 * the logo already shows correctly, so no inversion is ever required.
 *
 * NEVER blindly apply `dark:brightness-0 dark:invert` — that corrupts colored
 * logos (blueberry, fintokei purple, etc.).
 */
export interface FirmLogoMeta {
  invertInLight?: boolean;
}

export const FIRM_LOGO_META: Record<string, FirmLogoMeta> = {
  FTMO: { invertInLight: true },
  "Alpha Capital": { invertInLight: true },
  "Alpha Capital Group": { invertInLight: true },
  // Everything else has a colored mark or its own dark background —
  // those render correctly in both themes without any filter.
};

export function getFirmLogoMeta(firmName: string): FirmLogoMeta {
  return FIRM_LOGO_META[firmName] ?? {};
}
